import {noop} from 'lodash';
import {createContext, useState, useEffect, useContext, useMemo} from 'react';

const AuthContext = createContext({
  isAuthenticated: false,
  setIsAuthenticated: noop,
  loading: true,
});

export default function AuthProvider({children}) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // <== NEW

  useEffect(() => {
    const token = localStorage.getItem('login');
    setIsAuthenticated(!!token);
    setLoading(false); // Done checking
  }, []);

  const value = useMemo(() => ({
    isAuthenticated,
    setIsAuthenticated,
    loading,
  }), [isAuthenticated, loading]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
